import { handleActions } from "redux-actions";

import { COLLECTIONS } from "constants/action-types";

const initialState = {};

export default handleActions(
    {
        [COLLECTIONS.COLLECTION.BUDGET.CALCULATE.COMPLETED]: (
            state,
            { payload: { budgetId, currentQuantity, currentAmount } }: any,
        ): IBudgetState => {
            const currentBudget = state[budgetId];

            return {
                ...state,
                [budgetId]: {
                    ...currentBudget,
                    currentQuantity,
                    currentAmount,
                },
            };
        },
    },
    initialState,
);

interface IBudgetState {
    [budgetId: string]: IBudget;
}

interface IBudget {
    id: string;
    name: string;
    amount: number;
    quantity: number;
    dimensions: { [key: string]: string[] };
    currentQuantity: number;
    currentAmount: number;
}
